import request from "@/utils/request";
const qs = require("qs");
import { MLMReport } from "@/utils/requestApi";

// progresss

export function inspectionReport(data) {
  return request({
    url: MLMReport() + "/check_up/list",
    method: "POST",
    data: qs.stringify(data)
  });
}



// WEBPACK FOOTER //
// ./src/api/inspectionReport.js